import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    component: () => import('pages/LoginPage.vue'),
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/sr/workbench',
      },
      {
        path: 'dashboard',
        component: () => import('pages/IndexPage.vue'),
      },
      // 1000：系統帳權管理
      {
        path: 'system/users', // 對應左側選單的 link
        component: () => import('pages/system/UsersPage.vue'),
        meta: { featureCode: 1000, requiresAuth: true },
      },
      // 1100：系統角色管理
      {
        path: 'system/roles', // 對應左側選單的 link
        component: () => import('pages/system/RolePage.vue'),
        meta: { featureCode: 1100, requiresAuth: true },
      },
      // 1200 : 個人資料
      {
        path: 'profile',
        component: () => import('pages/system/ProfilePage.vue'),
        meta: { featureCode: 1200, requiresAuth: true },
      },
      // 2000：組織架構管理
      {
        path: 'system/org',
        component: () => import('pages/system/OrgPage.vue'),
        meta: { featureCode: 2000, requiresAuth: true },
      },
      {
        path: 'system/org/vendors',
        component: () => import('pages/system/VendorCustomerListPage.vue'),
        meta: { featureCode: 2000, requiresAuth: true },
      },
      {
        path: 'system/org/stations',
        component: () => import('pages/system/StationStoreListPage.vue'),
        meta: { featureCode: 2000, requiresAuth: true, orgDepth: 3, parentDepth: 2 },
      },
      {
        path: 'system/org/terminals',
        component: () => import('pages/system/StationStoreListPage.vue'),
        meta: { featureCode: 2000, requiresAuth: true, orgDepth: 4, parentDepth: 3 },
      },
      {
        path: 'exports',
        component: () => import('pages/system/ExportCenterPage.vue'),
        meta: { featureCode: 4000, requiresAuth: true },
      },
      {
        path: 'asset-exports',
        component: () => import('pages/system/AssetExportCenterPage.vue'),
        meta: { featureCode: 3000, requiresAuth: true },
      },
      // 3000：資產管理
      {
        path: 'assets',
        component: () => import('pages/asset/AssetListPage.vue'),
        meta: { featureCode: 3000, requiresAuth: true },
      },
      // 3100：資產機型管理
      {
        path: 'assets/types',
        component: () => import('pages/asset/AssetTypePage.vue'),
        meta: { featureCode: 3100, requiresAuth: true },
      },
      {
        path: 'assets/product-types',
        component: () => import('pages/asset/ProductTypePage.vue'),
        meta: { featureCode: 3100, requiresAuth: true },
      },
      // 4000：服務請求 (SR) 單管理
      {
        path: 'sr/list',
        redirect: (to) => ({
          path: '/sr/workbench',
          query: { ...to.query, tab: 'sr' },
        }),
        meta: { featureCode: 4000, requiresAuth: true },
      },
      {
        path: 'sr/workbench',
        component: () => import('pages/service/ServiceWorkOrderHubPage.vue'),
        meta: { featureCode: 4000, requiresAuth: true },
      },
      //TODO:
      {
        path: 'sr/customer',
        component: () => import('pages/service/MaintainCustomerPage.vue'),
        meta: { featureCode: 4100, requiresAuth: true },
      },
      // 5000：維修檢修 (Repair)
      {
        path: 'repair/list',
        redirect: (to) => ({
          path: '/sr/workbench',
          query: { ...to.query, tab: 'repair' },
        }),
        meta: { featureCode: 5000, requiresAuth: true },
      },
      // 6000：知識庫與字典 (Knowledge Base)
      {
        path: 'knowledge/base',
        component: () => import('pages/knowledge/KnowledgeBasePage.vue'),
        meta: { featureCode: 6000, requiresAuth: true },
      },
      // 4500：派工單管理 (客服端)
      {
        path: 'workorder/admin',
        redirect: (to) => ({
          path: '/sr/workbench',
          query: { ...to.query, tab: 'wo' },
        }),
        meta: { featureCode: 4500, requiresAuth: true },
      },
      // 7100：我的派工任務 (工程師現場端)
      {
        path: 'workorder/my',
        component: () => import('pages/workorder/MyWorkOrderPage.vue'),
        meta: { featureCode: 7100, requiresAuth: true },
      },
    ],
  },
  // 權限不足頁面
  {
    path: '/403',
    component: () => import('pages/ErrorForbidden.vue'),
  },
  // 404 捕獲
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
